import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import EmptyView from 'components/EmptyView';

const NoUnits = ({ openModal, unitName }) => (
  <EmptyView>
    <p>{`You don't have any ${unitName} yet.`}</p>
    <p>
      Go ahead and &nbsp;
      <Button data-test="create-button" isLink onClick={openModal}>
        create
      </Button>
      &nbsp;one!
    </p>
  </EmptyView>
);

NoUnits.propTypes = {
  openModal: PropTypes.func.isRequired,
  unitName: PropTypes.string.isRequired,
};

export default NoUnits;
